import React from 'react';
import { Field } from '@progress/kendo-react-form';
import { FormBoolRadioGroup } from '../../fields/FormBoolRadioGroup';
import { getRequiredValidator, isFieldOptional } from '../fieldMapperHelpers';
import { FieldMapperContext } from '../fieldMapperTypes';

export function renderBoolField(ctx: FieldMapperContext): React.ReactElement {
  const { ctField, fieldLabel, fieldDisabled, handleChange } = ctx;

  return (
    <Field
      key={ctField.name}
      name={ctField.name}
      component={FormBoolRadioGroup}
      label={fieldLabel}
      validator={getRequiredValidator(ctField)}
      optional={isFieldOptional(ctField)}
      onChange={handleChange}
      disabled={fieldDisabled}
    />
  );
}
